import { OkrAccordionSkeleton } from '@workboard/ui-okr';
import { TeamObjectiveCardList } from './TeamObjectiveCardList';
  
  
export const LazyObjectiveCardList = ({
  data: objectives,
  isLoading,
  krsLoader,
  isExpanded,
  onExpandChange,
  initialKrs,
  }) => {
  
  if (isLoading) {
    return (
      <>
        <OkrAccordionSkeleton />
        <OkrAccordionSkeleton />
      </>
    );
  }
  
  const groupedByTeam = objectives.reduce((acc, curr) => {
    const key = curr.teamName
      ? [curr.teamId, curr.teamName].join('|')
      : '-1|Individual';
    const currentTeam = acc.get(key) || [];
    currentTeam.push(curr);
    acc.set(key, currentTeam);
    return acc;
  },new Map());

  return (
    <>
      {Array.from(groupedByTeam.keys()).map((key) => {
        const [teamId, teamName] = key.split('|');
        return (
          <TeamObjectiveCardList
            key={`${teamId}-${teamName}`}
            teamId={teamId}
            teamName={teamName}
            objectives={groupedByTeam.get(key) ?? []}
            krsLoader={krsLoader}
            isExpanded={isExpanded}
            onExpandChange={onExpandChange}
            initialKrs={initialKrs}
          />
        );
      })}
     </>
  );
};
